module.exports = __webpack_public_path__ + "VAGRoundedStd-Light.22c13f9d3b22d1763841.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.woff
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.woff
// module chunks = styles